import * as React from 'react';
import { AnyObject } from 'final-form';
import { Page, Text, Document, StyleSheet, View } from '@react-pdf/renderer';
import PropertyUtil from 'src/util/PropertyUtil';
import moment from 'moment';
// import SignatureBlockManager from './SignatureBlockManager';
import Acknowledgement from 'src/models/leasing/Acknowledgement';
import SignatureBlock from 'src/models/leasing/SignatureBlock';
import LeaseClauseType from 'src/models/LeaseClauseType';
import LocationModel from 'src/models/leasing/LocationModel';
import ContractAdHocClause from '../../redesign/ContractGenerationModels/ContractAdHocClause';
import ContractAddendumClause from '../../redesign/ContractGenerationModels/ContractAddendumClause';
import IContract from 'src/models/contract_types/IContract';

const styles = StyleSheet.create({
    page: {
        backgroundColor: '#FFFFFF',
        padding: '1in',
        fontFamily: 'Times-Roman',
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 10,
        color: '#8e9094',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    bold: {
        fontFamily: 'Times-Bold',
    },
    fontNormal: {
        fontFamily: 'Times-Roman',
        fontSize: '11pt',
        lineHeight: 1.25,
    },
    mt1: {
        marginTop: 10,
    },
    mt2: {
        marginTop: 20,
    },
    mt3: {
        marginTop: 30,
    },
    mt4: {
        marginTop: 40,
    },
    center: {
        textAlign: 'center',
    },
    text: {
        textAlign: 'justify',
    },
    sbTitle: {
        textAlign: 'center',
        marginBottom: 10,
    },
    underlined: {
        textDecoration: 'underline',
    },
    mailingInfo: {
        fontSize: '11pt',
        fontFamily: 'Times-Roman',
    },
    acknowledgementHeading: {
        textAlign: 'center',
        fontSize: '12pt',
        fontWeight: 'bold',
    },
    exhibitHeading: {
        textAlign: 'center',
        fontSize: '12pt',
        fontWeight: 'bold',
    },
    leaseHeading: {
        textAlign: 'center',
        fontSize: '12pt',
        fontFamily: 'Times-Bold',
    },
    doubleLines: {
        borderTop: '1px solid black',
        borderBottom: '1px solid black',
    },
    h2: {
        fontSize: 14,
    },
    firstLvl: {
        marginLeft: '0.5in',
    },
    secondLvl: {
        marginLeft: '1in',
    },
    thirdLvl: {
        marginLeft: '1.5in',
    },
    fourthLvl: {
        marginLeft: '2in',
    },
});

export interface ISamsung1StateProps {
    contractData: IContract;
    contractAddendumClauses?: ContractAddendumClause[];
    contractClauseTypes?: LeaseClauseType[];
    locationData?: LocationModel;
}

export default class Samsung1 extends React.Component<ISamsung1StateProps> {
    private additionalProvisionNumber = 0;

    additionalProvisions = () => {
        let renderClauses: ContractAddendumClause[] = [];
        this.props.contractData.contractClauses.forEach((llc: AnyObject, index: number) => {
            let clause: ContractAddendumClause = !!this.props.contractAddendumClauses
                ? this.props.contractAddendumClauses.find((lc) => lc.id === llc.contractAddendumClauseId)
                : undefined;

            if (!!clause) {
                renderClauses.push(clause);
            }
        });

        return renderClauses?.map((rc: ContractAdHocClause, index: number) => {
            this.additionalProvisionNumber++;
            return (
                <Text key={index} style={[styles.fontNormal, styles.mt2, styles.text]}>
                    {this.additionalProvisionNumber}) {`${rc.leaseClauseTypeId}: ${rc.clauseText}`}
                </Text>
            );
        });
    };

    adhocProvisions = () => {
        const adHocClauses = this?.props?.contractData?.adHocClauses;
        if (adHocClauses?.length > 0) {
            return this.props?.contractData?.adHocClauses?.map((lc: ContractAdHocClause, index: number) => {
                let type: string = !!this.props?.contractClauseTypes
                    ? this.props?.contractClauseTypes?.find((lct) => lct.id === lc.leaseClauseTypeId)?.name
                    : '';

                this.additionalProvisionNumber++;
                return (
                    <Text key={index} style={[styles.fontNormal, styles.mt2, styles.text]}>
                        {this.additionalProvisionNumber}) {`${type}: ${lc.clauseText}`}
                    </Text>
                );
            });
        }
        return <div />;
    };

    displaySignatureBlocks = () => {
        return this.props?.contractData
            ? this.props?.contractData?.acknowledgements?.map((la: Acknowledgement) => {
                  return (
                      la.signatureBlocks.length > 0 &&
                      la.signatureBlocks.map((sb: SignatureBlock, index: number) => {
                          return (
                              <View key={index} wrap={false} style={{ marginRight: 10 }}>
                                  {!!sb.title && sb?.title.length > 0 && (
                                      <Text style={[styles.fontNormal, styles.mt3, styles.text, styles.bold]}>{sb?.title}</Text>
                                  )}
                                  <Text style={[styles.fontNormal, styles.mt2, styles.text]}>LESSOR:</Text>
                                  <Text style={[styles.fontNormal, styles.mt2, styles.text]}>______________________________________________</Text>
                                  <Text style={[styles.fontNormal, styles.mt1, styles.text]}>{sb.ownerName}</Text>
                              </View>
                          );
                      })
                  );
              })
            : [];
    };

    displayAcknowledgements = () => {
        return this.props?.contractData
            ? this.props?.contractData?.acknowledgements?.map((la: Acknowledgement, index: number) => {
                  return (
                      <View key={index} wrap={false}>
                          <Text style={[styles.fontNormal, styles.mt3, styles.text]}>{la.text}</Text>
                      </View>
                  );
              })
            : [];
    };

    // signatureBlocks = (leaseValues: AnyObject) => {
    //     return <SignatureBlockManager leaseValues={leaseValues} styles={styles} />;
    // };

    // tslint:disable: max-line-length
    render() {
        const rowValues = PropertyUtil.SafeGet(() => this.props.contractData);
        // const firstIncludedTract = rowValues?.tracts?.find((tract: AnyObject) => tract.includeTract === true);
        // const totalGrossAcres = rowValues?.tracts?.reduce((acc: number, tract: AnyObject) => {
        //     if (tract.includeTract === true) {
        //         let tempGrossAcres = parseFloat(tract.grossAcres) || 0;
        //         return acc + tempGrossAcres;
        //     } else {
        //         return acc;
        //     }
        // }, 0);

        return (
            <Document>
                <Page size="LEGAL" style={styles.page}>
                    <Text style={[styles.mailingInfo, styles.bold]}>After recording return to:</Text>
                    <Text style={styles.mailingInfo}>{PropertyUtil.SafeGet(() => rowValues.lesseeName, 'LESSEE NAME')}</Text>
                    <Text style={styles.mailingInfo}>{PropertyUtil.SafeGet(() => rowValues.lesseeAddressLine1, 'ADDRESS')}</Text>
                    <Text style={styles.mailingInfo}>{PropertyUtil.SafeGet(() => rowValues.lesseeAddressLine2, '')}</Text>
                    <Text style={styles.mailingInfo}>
                        {PropertyUtil.SafeGet(
                            () => rowValues.lesseeCity + ', ' + rowValues.lesseeState + ' ' + rowValues.lesseeZipCode,
                            'CITY, STATE, ZIP'
                        )}
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1]}>
                        NOTICE OF CONFIDENTIALITY RIGHTS: IF YOU ARE A NATURAL PERSON, YOU MAY REMOVE OR STRIKE ANY OR ALL OF THE FOLLOWING
                        INFORMATION FROM THIS INSTRUMENT BEFORE IT IS FILED FOR RECORD IN THE PUBLIC RECORDS:{' '}
                        <Text style={[styles.bold]}>YOUR SOCIAL SECURITY NUMBER OR YOUR DRIVER’S LICENSE NUMBER.</Text>
                    </Text>

                    <Text style={[styles.leaseHeading, styles.mt2, styles.underlined, styles.bold]}>WAIVER OF SURFACE RIGHTS AGREEMENT</Text>

                    <Text style={[styles.fontNormal, styles.mt2, styles.text]}>
                        This WAIVER OF SURFACE RIGHTS AGREEMENT (this “Agreement”) is made and entered into as of{' '}
                        {PropertyUtil.SafeGet(() => moment(rowValues.effectiveDate).format('Do'), 'DAY')} day of{' '}
                        {PropertyUtil.SafeGet(() => moment(rowValues.effectiveDate).format('MMMM'), 'MONTH')},{' '}
                        {PropertyUtil.SafeGet(() => moment(rowValues.effectiveDate).format('YYYY'), 'YEAR')}, by and among{' '}
                        {PropertyUtil.SafeGet(() => rowValues.ownersOnDocument, 'LESSOR NAME')} ("Mineral Owner"), and{' '}
                        {PropertyUtil.SafeGet(() => rowValues.lesseeName, 'LESSEE NAME')} ("Developer"). Mineral Owner and Developer may be referred
                        to herein individually as a “Party” and collectively as “Parties”. The Parties agree as follows:
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        WHEREAS, {PropertyUtil.SafeGet(() => rowValues.ownersOnDocument, 'LESSOR NAME')} owns certain mineral rights ("Mineral
                        Interest") under certain tracts of land in {!!this.props.locationData && this.props.locationData?.counties[0]} County,{' '}
                        {!!this.props.locationData && this.props.locationData?.state}, being more particularly described in Exhibit A attached hereto
                        and made a part of this Agreement ("Premises"); and
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        WHEREAS, {PropertyUtil.SafeGet(() => rowValues.surfaceWaiverHolds[0].surfaceOwner.name, 'SURFACE OWNER')} (“Surface Owner”) is
                        the fee title owner of the surface estate of the Premises; and
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        WHEREAS, {PropertyUtil.SafeGet(() => rowValues.ownersOnDocument, 'LESSOR NAME')} has plans to develop the surface of the
                        Premises, or portions thereof, which shall not exceed {PropertyUtil.SafeGet(() => rowValues.grossAcres, 'GROSS ACRES')} acres,
                        being more particularly described in Exhibit B attached hereto and made a part of this Agreement (“BESS Site”), and has
                        entered into that certain Option to Lease Agreement dated __________, 20__, by and between Developer and Surface Owner, as
                        evidenced by that certain Memorandum of Option to Lease Agreement dated __________, 20__, recorded as Document #__________ in
                        the Official Public Records of {!!this.props.locationData && this.props.locationData?.counties[0]} County,{' '}
                        {!!this.props.locationData && this.props.locationData?.state}, (as the same may be amended from time to time, the “Surface
                        Option”); and
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        WHEREAS, the Parties have entered into this Agreement to (a) facilitate the use of the BESS Site for Developer’s development,
                        construction and operation of battery energy storage system(s) and related equipment, facilities and improvements on the BESS
                        Site (the “Project”); and (b) release and relinquish Mineral Lessee’s right to use and enter upon the surface of the BESS Site
                        in connection with Mineral Lessee’s development of the Premises for oil, gas, and other minerals, subject to the terms and
                        conditions below.
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        NOW, THEREFORE, for good and valuable consideration of the sum of ten Dollars ($10), the consideration specified in Exhibit C
                        to this Agreement, and for other valuable consideration, the receipt and sufficiency of which are hereby acknowledged, the
                        Parties hereto, intending to be legally bound, do hereby agree as follows:
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        1. Developer has entered into the Surface Option covering the Premises, to design, develop, construct, install, maintain, use,
                        test and operate the Project on the BESS Site, the location of which shall remain subject to Developer’s sole discretion. The
                        Parties agree that Mineral Lessee does not own any interest in the fee ownership of the surface estate.
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        2. Mineral Lessee, on behalf of itself and any of its successors and assigns, and any other party claiming by, through or
                        under Mineral Lessee, (i) expressly waives, releases and relinquishes all rights of ingress and egress and all other rights of
                        every kind and character whatsoever to enter upon or to use the surface of the BESS Site and the 500 feet directly below the
                        surface of the BESS Site, including, without limitation, the right to enter upon the surface of the BESS Site and the 500 feet
                        directly below the surface of the BESS Site for purposes of exploring for, testing, developing, drilling, extracting,
                        producing, taking, treating, processing, storing or transporting oil, gas, hydrocarbons of any nature, and or minerals of any
                        kind or nature, and (ii) further agrees not to use, enter upon, access or occupy any portion of the surface of the BESS Site
                        and the 500 feet directly below the surface of the BESS Site and not to place or construct any fixtures, equipment, buildings,
                        structures, machinery or other improvements thereon; provided, however, nothing contained in this Agreement shall be construed
                        as waiving Mineral Lessee’s rights with respect to, or as preventing Mineral Lessee from exploring for, developing or
                        producing, all such oil, gas, and other minerals by directional drilling and/or horizontal drilling under the BESS Site from
                        well sites located on tracts other than the BESS Site (and to depths greater than 500 feet below the surface of the BESS
                        Site); provided, further, that all such exploring, development and production are substantially in accordance with all
                        applicable laws, regulations, ordinances, codes and statutes of the State of Texas and all other governmental bodies having
                        jurisdiction over all or any portion of the Premises.
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        3. This Agreement is effective as of the Effective Date and will continue in full force and effect for fifty (50) years (the
                        <Text style={[styles.fontNormal, styles.text, styles.bold]}> “Term”</Text>). Any lease of oil, gas and/or other minerals now
                        on or hereafter covering the Premises, or any portion thereof, shall be expressly made subject to the terms and provisions of
                        this Agreement. Notwithstanding the foregoing, this Agreement shall terminate if, prior to the expiration of the Term, the
                        Surface Option expires or terminates and the Developer has not exercised its option to enter into a lease as provided in and
                        attached to the Surface Option (the <Text style={[styles.fontNormal, styles.text, styles.bold]}>“Surface Lease”</Text>), or,
                        if the Developer exercises its option and enters into the Surface Lease, the Surface Lease expires or terminates, or the
                        Project is decommissioned and removed from the BESS Site.
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        4. In consideration of the rights granted in this Agreement, Developer shall pay to Mineral Lessee the amount set forth in
                        Exhibit C attached hereto. Notwithstanding anything in this Agreement to the contrary, Developer shall have no obligation to
                        make any payment to Mineral Lessee otherwise required under this Agreement until Mineral Lessee has returned to Developer a
                        completed Internal Revenue Service Form W-9. An original copy of this Agreement shall be recorded in the Official Public
                        Records of __________ County, Texas. The Parties hereby agree that Exhibit C to this Agreement shall be removed before the
                        same is filed of record.
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        5. This Agreement may be assigned in whole or in part by Developer in connection with such Developer’s assignment of its
                        interest in the Premises and any related facilities, and may be collaterally assigned by Developer. The terms and conditions
                        of this Agreement shall be binding upon, and shall inure to the benefit of the Parties and their respective heirs, legal
                        representatives, successors, and assigns, and shall be covenants running with the Premises, and the mineral and the surface
                        estates therein.
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        6. The Parties shall from time to time execute any further documents reasonably necessary or desirable to effectuate the
                        intent of the Parties to waive the surface rights of Mineral Lessee in the manner and according to the terms in this
                        Agreement.
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        7. Mineral Lessee hereby represents and warrants that (a) Mineral Lessee and each person signing this Agreement on behalf of
                        Mineral Lessee has the full and unrestricted power and authority to execute and deliver this Agreement and to waive its right
                        to access and use the surface of the Premises and the other rights herein granted, and (b) as of the Effective Date, there are
                        no leases, easements, or other agreements that have been executed by Mineral Lessee that relate to or grant any interest in or
                        to the Mineral Interest (or any portion thereof) to any third party.
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        8. The Parties agree that money damages may not be a sufficient remedy for any breach of this Agreement by Mineral Lessee and
                        that, in addition to all other remedies, Developer shall be entitled to specific performance and injunctive or other equitable
                        relief as a remedy for such breach (including, without limitation, the right to remove any of the other Mineral Lessee’s
                        equipment or third party equipment from the Property).
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        9. In any dispute between the Parties, whether or not resulting in litigation, the prevailing Party shall be entitled to
                        recover from the other Party all reasonable costs.{' '}
                        <Text style={[styles.fontNormal, styles.text, styles.bold]}>“Prevailing Party”</Text> shall include a Party who dismisses an
                        action for recovery in exchange for sums allegedly due, performance for covenants allegedly breached or considerations
                        substantially equal to the relief sought in the action, or which receives, in connection with any dispute, performance from
                        the other Party substantially equivalent to any of these.
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        10. All notices from a Party must be sent to the other Party at its address below, which address may be changed, from time to
                        time, by either Party giving written notice to the other.
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>Notice addresses are as follows:</Text>
                    <View style={[styles.secondLvl, { marginBottom: 10 }]}>
                        <View style={{ display: 'flex', marginLeft: 10 }}>
                            <View>
                                <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                                    To {PropertyUtil.SafeGet(() => rowValues.ownersOnDocument, 'LESSOR NAME')}:{' '}
                                </Text>
                            </View>
                            <View>
                                <Text style={[styles.fontNormal, styles.mt1, styles.text, { marginLeft: 3 }]}>
                                    {PropertyUtil.SafeGet(() => rowValues.ownersAddressOnDocument, 'LESSOR ADDRESS')}
                                </Text>
                            </View>
                        </View>
                        <View style={{ display: 'flex', marginLeft: 10 }}>
                            <View>
                                <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                                    If to {PropertyUtil.SafeGet(() => rowValues.lesseeName, 'LESSEE NAME')}:{' '}
                                </Text>
                            </View>
                            <View>
                                <Text style={[styles.fontNormal, styles.mt1, styles.text, { marginLeft: 3 }]}>
                                    {PropertyUtil.SafeGet(
                                        () =>
                                            rowValues.lesseeAddressLine1 +
                                            ', ' +
                                            rowValues.lesseeCity +
                                            ', ' +
                                            rowValues.lesseeState +
                                            ', ' +
                                            rowValues.lesseeZipCode,
                                        'LESSEE ADDRESS'
                                    )}
                                </Text>
                            </View>
                        </View>
                    </View>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        11. This Agreement shall be governed by and construed and enforced and performed in accordance with the laws of the State of
                        Texas, without regard for its conflicts of law principles. The Parties agree to waive any and all rights that they may now or
                        hereafter have under the laws of the United States of America or any State, to a trial by a jury of any and all issues arising
                        directly or indirectly in any action or proceeding relating to this Agreement or any transactions contemplated hereby or
                        related hereto.
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        12. If any provision of this Agreement is deemed illegal, invalid, or unenforceable, then the remainder of this Agreement will
                        not be affected thereby. The Parties acknowledge that this Agreement, as executed, is the product of negotiations between the
                        Parties and that it shall be construed fairly, in accordance with its terms, and shall not be construed for or against either
                        Party by reason of the drafting or preparation hereof. No inferences as to the intention of the Parties shall arise from the
                        deletion of any language or provisions of this Agreement.
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        13. This Agreement constitutes the entire agreement between the Parties regarding use of the Premises. This Agreement may be
                        executed in any number of counterparts with the same effect as if both Parties had signed the same document. All counterparts
                        shall be construed together and shall constitute one and the same instrument. The Parties hereby acknowledge and agree that
                        facsimile signatures or signatures transmitted by electronic mail in so-called “pdf” format shall be legal and binding and
                        shall have the same full force and effect as if an original of this Agreement had been delivered. If any provision of this
                        Agreement conflicts with the terms contained in the Surface Option and/or Surface Lease, then the terms of this Agreement
                        shall control.
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        14. No waiver or consent, express or implied, by any Party to or of any breach of default by any Party in the performance by
                        such Party of its obligations hereunder shall be deemed or construed to be a consent or waiver to or of any other breach or
                        default in the performance by such Party of the same or any other obligations of such Party hereunder. Failure on the part of
                        a Party to complain of any act of any Party or to declare any Party in default, irrespective of how long such failure
                        continues, shall not constitute a waiver by such Party of its rights hereunder until the applicable statute of limitation
                        period has run.
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.firstLvl]}>
                        15. This Agreement, together with its exhibits, contains the complete agreement between the Parties and supersedes any and all
                        prior or contemporaneous discussions, agreements, undertakings, representations and commitments whatsoever, whether written or
                        oral, between the Parties with respect to the matters contained herein. This Agreement may not be modified or amended unless
                        such amendment is set forth in writing and executed by duly authorized signatories of both Parties. The Parties agree that
                        there are no oral agreements, understandings, representations or warranties which are not expressly set forth herein.
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text, { textAlign: 'center', marginTop: 30 }]}>
                        [ACKNOWLEDGEMENTS AND SIGNATURES ARE DISPLAYED IN THE NEXT PAGES]
                    </Text>

                    <Text
                        style={styles.pageNumbers}
                        render={({ pageNumber }) => {
                            return `${pageNumber}`;
                        }}
                        fixed={true}
                    />
                </Page>

                {PropertyUtil.SafeGet(() => rowValues.acknowledgements.length > 0) && (
                    <Page size="LEGAL" style={styles.page}>
                        <Text style={[styles.fontNormal, styles.mt3, styles.sbTitle]}>
                            IN WITNESS THEREOF, BY EXECUTION OF THE AGREEMENT, both Parties hereto agree to the terms contained herein and freely
                            execute this Agreement being effective the latter of the date written above or the date of the Developer’s signature below
                            ("<Text style={[styles.bold]}>the Effective Date</Text>").
                        </Text>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', rowGap: '5rem' }}>
                            {this.displaySignatureBlocks()}
                        </div>
                        <Text style={[styles.acknowledgementHeading, styles.mt2]}>(ACKNOWLEDGEMENT)</Text>
                        {this.displayAcknowledgements()}
                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>
                )}

                <Page size="LEGAL" style={styles.page}>
                    <Text style={[styles.exhibitHeading, styles.bold]}>Exhibit A</Text>
                    <Text style={[styles.fontNormal, styles.mt2, styles.center]}>Premises</Text>

                    <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                </Page>

                <Page size="LEGAL" style={styles.page}>
                    <Text style={[styles.exhibitHeading, styles.bold]}>Exhibit B</Text>
                    <Text style={[styles.fontNormal, styles.mt2, styles.center]}>BESS Site</Text>
                    <Text style={[styles.fontNormal, styles.mt2, styles.text]}>
                        {PropertyUtil.SafeGet(() => rowValues.legalDescription, 'LEGAL DESCRIPTION')}
                    </Text>

                    <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                </Page>

                <Page size="LEGAL" style={styles.page}>
                    <Text style={[styles.exhibitHeading, styles.bold]}>Exhibit C</Text>
                    <Text style={[styles.fontNormal, styles.mt2, styles.center]}>Payment Terms</Text>

                    <Text style={[styles.fontNormal, styles.mt2, styles.bold, styles.center]}>[EXHIBIT C TO BE REMOVED PRIOR TO RECORDING]</Text>

                    <Text style={[styles.fontNormal, styles.mt3, styles.text]}>
                        Developer shall pay to Mineral Owner up to two (2) payments, as follows:
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text, { marginLeft: 20 }]}>
                        A. A one-time payment equal to fifty percent (50%) of _______________ Dollars ($ ______.__ USD) multiplied by the Net Mineral
                        Acres, to be paid within sixty (60) days of the Effective Date; and
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text, { marginLeft: 20 }]}>
                        B. If Developer enters into the Surface Lease, a one-time payment equal to fifty percent (50%) of _______________ Dollars ($
                        ______.__ USD) multiplied by the Net Mineral Acres, to be paid within ninety (90) days of the Surface Lease effective date.
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt2, styles.text]}>
                        <Text style={[styles.fontNormal, styles.text, styles.bold]}>“Net Mineral Acres”</Text> used herein means the product of (i)
                        total number of gross acres of the BESS Site covered by the Surface Option, multiplied by (ii) the Mineral Owner’s undivided
                        Mineral Interest in the BESS Site covered by such Surface Option.
                    </Text>

                    <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                </Page>

                {/* <Page size="LEGAL" style={styles.page}>
                    <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                </Page> */}

                {/* <Page size="LEGAL" style={styles.page}>

                    <Text style={[styles.fontNormal, styles.mt2, styles.text]}>
                        IN TESTIMONY WHEREOF, I sign the ____ day of ___________________, 20____,
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt4, styles.text]}>
                        LESSOR:
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt4, styles.text]}>
                        ______________________________________________
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        {PropertyUtil.SafeGet(() => leaseValues.lessor.name, 'LESSOR')}
                    </Text>

                    <Text style={[styles.fontNormal, styles.center, styles.mt3, styles.h2]}>
                        (ACKNOWLEDGMENT)
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        STATE OF ________________________
                         </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        COUNTY OF ________________________
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        Before me, the udnersigned, a Notary Public, in and for said county and State, on this ____ day of ____________________, 20___, personally appeared ____________________, an
                        individual, personally known to me
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt1]}>
                        to be the identical person who executed the within and foregoinginstrument, and acknowledged to me that he executed the same as his free and voluntary act and deed, for the
                        use and purposes therein set forth.
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt1]}>
                        Notary Public
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        Print Name _______________________________________
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        My Commission expires: ________________________
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        Commission Number: ________________________
                        </Text>

                    <Text
                        style={styles.pageNumbers}
                        render={({ pageNumber }) => (
                            `${pageNumber}`
                        )}
                        fixed={true}
                    />

                    {this.signatureBlocks()}
                </Page> */}

                {/* {PropertyUtil.SafeGet(() => rowValues.acknowledgements.length > 0) && (
                    <Page size="LEGAL" style={styles.page}>
                        <Text style={[styles.acknowledgementHeading, styles.mt3]}>(ACKNOWLEDGEMENT)</Text>
                        {this.displayAcknowledgements()}
                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>
                )} */}

                {/* {PropertyUtil.SafeGet(() => rowValues?.legalDescription.length > 1000) && (
                    <Page size="LEGAL" style={styles.page}>
                        <Text style={styles.exhibitHeading}>Exhibit A</Text>
                        <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                            {PropertyUtil.SafeGet(() => rowValues.legalDescription, 'LEGAL DESCRIPTION')}
                        </Text>
                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>
                )} */}

                <Page size="LEGAL" style={styles.page}>
                    <Text style={styles.exhibitHeading}>Exhibit D</Text>
                    <Text style={[styles.fontNormal, styles.mt3, styles.h2]}>Additional Provisions</Text>

                    {!!rowValues?.contractClauses && rowValues?.contractClauses?.length > 0 && this.additionalProvisions()}
                    {!!rowValues?.adHocClauses && rowValues?.adHocClauses?.length > 0 && this.adhocProvisions()}

                    <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                </Page>
            </Document>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/LeaseDocuments/SurfaceWaiverLeaseDocs/Samsung1.tsx